var Application;

Application = require('application');

$(function() {
  return (new Application).initialize();
});
